<template>
  <form @submit.prevent="onPay" class="flex flex-col sm:flex-row">
    <input
      type="text"
      class="
        sm:flex-grow
        w-full
        h-12
        py-3
        px-5
        leading-relaxed
        text-input-color
        bg-input-bg bg-clip-padding
        border border-solid border-input-bg
        focus:border-input-border
        rounded-md
        shadow-none
        transition-colors
      "
      placeholder="Ej: 8.164.251-3"
      onfocus="this.placeholder = ''"
      onblur="this.placeholder = 'Ej: 8.164.251-3'"
      v-model="taxId"
      @keydown="taxIdOnKeyDown"
      @paste.prevent="taxIdOnPaste"
    />
    <button
      type="submit"
      class="
        sm:flex-grow-0
        mt-3
        sm:mt-0
        sm:ml-3
        w-full
        sm:w-44
        h-12
        py-3
        px-8
        font-semibold
        text-center
        align-middle
        select-none
        border-none
        shadow-button
        transition-colors
        duration-500
        rounded-md
        cursor-pointer
        bg-base-color
      "
    >
      Buscar
    </button>
  </form>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    //voucher: Object as PropType<Voucher>,
  },
  emits: ["pay"],
})
export default class SearchForm extends Vue {
  taxId = "";
  //voucher!: Voucher;

  onPay(e: Event): void {
    this.$emit("pay", this.taxId);
  }

  taxIdOnKeyDown(e: KeyboardEvent): void {
    if (e.isComposing || e.keyCode === 229 || !e.keyCode) {
      e.preventDefault();
    }

    if (
      e.key === "Enter" ||
      (e.ctrlKey && "zcv".includes(e.key.toLowerCase()))
    ) {
      return;
    }

    if (e.key === "x") {
      const element = e.target as HTMLInputElement;

      e.preventDefault();
      return;
    }

    // console.log("KEY:" + e.key);
    // console.log("KEYC:" + e.key.charCodeAt(0));
    // console.log(this.taxId);

    // delete|backspace selection
    const keyCode = e.keyCode;

    if (keyCode > 34 && keyCode < 41) return;

    const element = e.target as HTMLInputElement;
    let index = element.selectionStart || 0;
    if (
      (keyCode === 8 || keyCode === 46) &&
      this.taxId.substring(index, element.selectionEnd || 0).length != 0
    ) {
      this.taxId = this.taxIdValidatorRecalculate(
        this.taxId.slice(0, index) + this.taxId.slice(element.selectionEnd || 0)
      );
      element.setSelectionRange(index, index);
    } else if (keyCode === 8 && index != 0) {
      let i = index - 1;
      let char = this.taxId.charAt(i);
      if (char === "." || char === "-") i -= 1;
      this.taxId = this.taxIdValidatorRecalculate(
        this.taxId.slice(0, i) + this.taxId.slice(index)
      );
      let dx = i - this.taxId.length + this.taxId.length + 1;
      element.setSelectionRange(dx, dx);
    } else if (keyCode === 46 && index < this.taxId.length) {
      let i = index + 1;
      let char = this.taxId.charAt(index);
      if (char === "." || char === "-") i += 1;
      this.taxId = this.taxIdValidatorRecalculate(
        this.taxId.slice(0, index) + this.taxId.slice(i)
      );
      element.setSelectionRange(index, index);
    } else {
      let key = e.key.toUpperCase();
      if (/^[0-9]$/i.test(e.key) || key === "K") {
        if (this.taxId.slice(-1) === "K" || this.taxId.length > 12) {
          e.preventDefault();
          return;
        }

        this.taxId = this.taxIdValidatorRecalculate(
          this.taxId.slice(0, index) + key + this.taxId.slice(index)
        );
        index += this.taxId.length - this.taxId.length;
        element.setSelectionRange(index, index);
      }
    }

    e.preventDefault();
  }

  taxIdOnPaste(e: ClipboardEvent): void {
    const data = e.clipboardData?.getData("text");
    if (data) {
      const element = e.target as HTMLInputElement;
      const newValue =
        this.taxId.slice(0, element.selectionStart || 0) +
        data +
        this.taxId.slice(element.selectionEnd || 0);
      this.taxId = this.taxIdValidatorRecalculate(newValue);
    }
  }

  private numberFormater(n: string): string {
    const r = /(\d+)(\d{3})/;
    while (r.test(n)) {
      n = n.replace(r, "$1" + "." + "$2");
    }
    return n;
  }

  private taxIdValidatorRecalculate(str: string): string {
    const s = str.replace(/[.-]/g, "");
    if (s.length <= 1) return s;
    return this.numberFormater(s.slice(0, -1)) + "-" + s.slice(-1);
  }
}
</script>
